export const fetchWordOfTheDay = async () => {

}

export const validateWord = async (word) => {
    
    if (!word) return false;
    try {
        const response = await fetch(`https://api.dictionaryapi.dev/api/v2/entries/en/${word}`);
        return response.ok;
    } catch (err) {
        console.error("Fetch error:", err);
        return false;
    }

}